export default __webpack_public_path__ + "static/etica-procese-0905651187196c0ec490adb699f727ac.jpg";